/** Public site origin for auth redirects (email links). Prefer NEXT_PUBLIC_SITE_URL in production. */
export function getAuthSiteOrigin(): string {
  if (typeof window === "undefined") return "";
  // On Vercel Preview deploys (*.vercel.app) NEXT_PUBLIC_SITE_URL is baked from
  // the Production env at build time, so trusting it would leak OAuth redirects
  // back to prod. Use the actual origin instead — Previews self-isolate.
  if (window.location.host.endsWith(".vercel.app")) {
    return window.location.origin;
  }
  const fromEnv = process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, "").trim();
  if (fromEnv) return fromEnv;
  return window.location.origin;
}

/**
 * Absolute URL for Supabase OAuth (e.g. Google) PKCE callback.
 * Must be listed under Authentication → URL Configuration → Redirect URLs in Supabase.
 *
 * `next` is forwarded so the server callback knows where to land the user
 * after exchanging the code — without this, the callback hardcodes /projects
 * and the homepage prompt-resume flow never runs. Only same-origin relative
 * paths are passed through; anything else is dropped silently so a hostile
 * `next` can't redirect through us.
 */
export function buildOAuthCallbackUrl(next?: string): string | null {
  const origin = getAuthSiteOrigin();
  if (!origin) {
    console.warn("[oauth] buildOAuthCallbackUrl: no origin available");
    return null;
  }
  const base = `${origin}/auth/callback`;
  if (!next) {
    return base;
  }
  if (!next.startsWith("/") || next.startsWith("//")) {
    console.warn("[oauth] buildOAuthCallbackUrl: unsafe next dropped", {
      next,
    });
    return base;
  }
  const url = `${base}?next=${encodeURIComponent(next)}`;
  return url;
}
